module.exports = __webpack_public_path__ + "img/logo.f7196740.svg";